import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';

import { ConfigServerService, CustomHttp } from '../../../../core';

@Injectable({
    providedIn: 'root'
})
export class LeadUpdateHttpService {
    private pathApi: string;

    constructor(configServerService: ConfigServerService,
                private customHttp: CustomHttp) {
        this.pathApi = `${configServerService.getPathApi()}/crm/lead`;
    }

    /** Atualiza a temperatura do lead */
    updateTemperatura(id: number, temperatura: number): Observable<string> {
        return this.customHttp.put<string>(`${this.pathApi}/${id}/temperatura/${temperatura}`, null);
    }
}
